import { Discount } from '@slerp/controls'

export const toStringList = (value: string[]) => {
  return `{${value?.join(',')}}`
}
export const formatCategoryValues = (categories: { category_id: string }[]) =>
  categories.map((item: { category_id: string }) => item.category_id)

export const formatProductValues = (
  products_discount: {
    product: { products_categories: { category_id: string }[] }
    product_id: string
  }[]
) => {
  let categorizedProducts: Record<string, string[]> = {}

  products_discount.forEach(({ product, product_id }) => {
    product.products_categories.forEach(({ category_id }) => {
      categorizedProducts = {
        ...categorizedProducts,
        [category_id]: [...(categorizedProducts[category_id] || []), product_id]
      }
    })
  })

  return categorizedProducts
}

export const getDiscountProperties = ({
  target,
  trigger,
  store_ids,
  merchantStoresDeliveryPricingBands
}: Discount) => {
  const isDelivery = target === 'DELIVERY_FEE'
  const isAutomatic = trigger === 'automatic'
  const isAvailableAllStores = (store_ids || []).length === 0

  const storeIdsWithPricingBands = (store_ids || []).filter((storeId: string) =>
    (merchantStoresDeliveryPricingBands || []).includes(storeId)
  )

  const isBlockedByActivePricingBands =
    isDelivery &&
    isAutomatic &&
    ((!!(merchantStoresDeliveryPricingBands || []).length &&
      isAvailableAllStores) ||
      !!storeIdsWithPricingBands.length)

  return {
    isDelivery,
    isAutomatic,
    isAvailableAllStores,
    isBlockedByActivePricingBands
  }
}
